import actions from './actions';

const {
  LIST_MADA_BANK_BATCHES_BEGIN,
  LIST_MADA_BANK_BATCHES_SUCCESS,
  LIST_MADA_BANK_BATCHES_ERR,
  UPLOAD_MADA_BANK_REPORT_BEGIN,
  UPLOAD_MADA_BANK_REPORT_SUCCESS,
  UPLOAD_MADA_BANK_REPORT_ERR,
  GET_MADA_BANK_BATCH_BEGIN,
  GET_MADA_BANK_BATCH_SUCCESS,
  GET_MADA_BANK_BATCH_ERR,
  LIST_MADA_BANK_SETTLEMENTS_BEGIN,
  LIST_MADA_BANK_SETTLEMENTS_SUCCESS,
  LIST_MADA_BANK_SETTLEMENTS_ERR,
  LIST_MADA_APPROVED_NOT_SETTLED_BEGIN,
  LIST_MADA_APPROVED_NOT_SETTLED_SUCCESS,
  LIST_MADA_APPROVED_NOT_SETTLED_ERR,
  GET_MADA_DISCREPANCY_SUMMARY_BEGIN,
  GET_MADA_DISCREPANCY_SUMMARY_SUCCESS,
  GET_MADA_DISCREPANCY_SUMMARY_ERR,
} = actions;

const initState = {
  batches: [],
  totalBatches: 0,
  loadingListMadaBankBatches: false,
  errorListMadaBankBatches: '',

  loadingUploadMadaBankReport: false,
  errorUploadMadaBankReport: '',

  batchDetails: {},
  loadingGetMadaBankBatch: false,
  errorGetMadaBankBatch: '',

  settlements: [],
  totalSettlements: 0,
  loadingListMadaBankSettlements: false,
  errorListMadaBankSettlements: '',

  approvedNotSettled: [],
  totalApprovedNotSettled: 0,
  loadingListMadaApprovedNotSettled: false,
  errorListMadaApprovedNotSettled: '',

  discrepancySummary: {},
  loadingGetMadaDiscrepancySummary: false,
  errorGetMadaDiscrepancySummary: '',
};

const MadaReconciliationReducer = (state = initState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case LIST_MADA_BANK_BATCHES_BEGIN:
      return {
        ...state,
        loadingListMadaBankBatches: true,
        errorListMadaBankBatches: null,
        totalBatches: 0,
      };
    case LIST_MADA_BANK_BATCHES_SUCCESS:
      return {
        ...state,
        batches: [...data.results],
        totalBatches: data.total_count,
        loadingListMadaBankBatches: false,
        errorListMadaBankBatches: null,
      };
    case LIST_MADA_BANK_BATCHES_ERR:
      return {
        ...state,
        errorListMadaBankBatches: err,
        loadingListMadaBankBatches: false,
      };

    case UPLOAD_MADA_BANK_REPORT_BEGIN:
      return {
        ...state,
        loadingUploadMadaBankReport: true,
        errorUploadMadaBankReport: null,
      };
    case UPLOAD_MADA_BANK_REPORT_SUCCESS:
      return {
        ...state,
        loadingUploadMadaBankReport: false,
        errorUploadMadaBankReport: null,
      };
    case UPLOAD_MADA_BANK_REPORT_ERR:
      return {
        ...state,
        errorUploadMadaBankReport: err,
        loadingUploadMadaBankReport: false,
      };

    case GET_MADA_BANK_BATCH_BEGIN:
      return {
        ...state,
        loadingGetMadaBankBatch: true,
        errorGetMadaBankBatch: null,
      };
    case GET_MADA_BANK_BATCH_SUCCESS:
      return {
        ...state,
        batchDetails: data,
        loadingGetMadaBankBatch: false,
        errorGetMadaBankBatch: null,
      };
    case GET_MADA_BANK_BATCH_ERR:
      return {
        ...state,
        errorGetMadaBankBatch: err,
        loadingGetMadaBankBatch: false,
      };

    case LIST_MADA_BANK_SETTLEMENTS_BEGIN:
      return {
        ...state,
        loadingListMadaBankSettlements: true,
        errorListMadaBankSettlements: null,
        totalSettlements: 0,
      };
    case LIST_MADA_BANK_SETTLEMENTS_SUCCESS:
      return {
        ...state,
        settlements: [...data.results],
        totalSettlements: data.total_count,
        loadingListMadaBankSettlements: false,
        errorListMadaBankSettlements: null,
      };
    case LIST_MADA_BANK_SETTLEMENTS_ERR:
      return {
        ...state,
        errorListMadaBankSettlements: err,
        loadingListMadaBankSettlements: false,
      };

    case LIST_MADA_APPROVED_NOT_SETTLED_BEGIN:
      return {
        ...state,
        loadingListMadaApprovedNotSettled: true,
        errorListMadaApprovedNotSettled: null,
        totalApprovedNotSettled: 0,
      };
    case LIST_MADA_APPROVED_NOT_SETTLED_SUCCESS:
      return {
        ...state,
        approvedNotSettled: [...data.results],
        totalApprovedNotSettled: data.total_count,
        loadingListMadaApprovedNotSettled: false,
        errorListMadaApprovedNotSettled: null,
      };
    case LIST_MADA_APPROVED_NOT_SETTLED_ERR:
      return {
        ...state,
        errorListMadaApprovedNotSettled: err,
        loadingListMadaApprovedNotSettled: false,
      };

    case GET_MADA_DISCREPANCY_SUMMARY_BEGIN:
      return {
        ...state,
        loadingGetMadaDiscrepancySummary: true,
        errorGetMadaDiscrepancySummary: null,
      };
    case GET_MADA_DISCREPANCY_SUMMARY_SUCCESS:
      return {
        ...state,
        discrepancySummary: data,
        loadingGetMadaDiscrepancySummary: false,
        errorGetMadaDiscrepancySummary: null,
      };
    case GET_MADA_DISCREPANCY_SUMMARY_ERR:
      return {
        ...state,
        errorGetMadaDiscrepancySummary: err,
        loadingGetMadaDiscrepancySummary: false,
      };

    default:
      return state;
  }
};

export { MadaReconciliationReducer };
